module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"repeat":"Wiederholen"},"en":{"repeat":"Repeat"}}')
  delete Component.options._Ctor
}
